import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import SimpleFieldGenerator from '../../../simpleFieldGenerator';

class CreateLessonTemasSection extends Component{
  constructor(props){
    super(props);
    this.state={
      objectiveData: []
    }
    this.setObjectiveData = this.setObjectiveData.bind(this);
  }

  setObjectiveData(content){
    this.props.parentStateHandle("lessonTransversalThemes", content);
  }

  render(){
    return(
      <div>
        <h3><FormattedMessage id="cl-topics-title"/></h3>
        {this.props.isValidated ? <p style={{color: "red"}}><FormattedMessage id="va-lesson-richtext"/></p> : ""}
        <p><FormattedMessage id="cl-field-instruction"/></p>
        <SimpleFieldGenerator 
          titleId="cl-topic" 
          setParentState={this.setObjectiveData}
          state={this.props.state}
        />
      </div>
    );
  }
}

export default CreateLessonTemasSection;